<template>
  <div>


    <pageTable
                ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :tableData="tableData"
                tableApi="admin/finance/getRecord"
    >

      <!-- <div style="margin-top: 20px;">
      <Page :total="total" :current.sync="currentPage" @on-change="handlePageChange" />
    </div> -->
       <!-- <template v-slot:searchFormItem>
   
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>

     
      </template> -->
    </pageTable>
  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'
  export default {
    name: "financialRecords",
    components:{pageTable},
    props:{
      station_id:{
        type:Number,
        default: 0
      },
      dataForm:{
         type:Array,
        default: 0
      }
      
 
    },
    data(){
      return {
        searchData:{
          keyword:'',
          pagesize:100,
          station_id:this.station_id,
          type:2,
          dataForm:this.dataForm
          
        },
        multiPrice:'',
        do_time:'',
        doingMultiSet:false,
        tableColumn: [
        //   {title: '渠道id',type: 'station_id',align: "center",width:80},
       {title: '站点名称',key: 'name',align: "left",render:(h,params)=>{
              return h('div',[
                h('span',params.row.gas_name),
                h('Tag',{props:{color:'orange'}},params.row.platform),
              ])
            }},
          {title: '业务类型',key: 'station_name',align: "left",render:(h,params)=>{
            if (params.row.company_name==='汇总'){
              return h('span','')
            }else{
              return h('span',params.row.is_station_bill  ? 'A型' : 'B型')
            }
            }},
          {title: '业务员',key: 'salesman',align: "left"},
          {title: '加油数量',key: 'litre_num',align: "left"},
          {title: '成本A',key: 'bill_price',align: "left"},
          {title: '成本B',key: 'no_bill_price',align: "left"},
          {title: '下单时间',key: 'create_time',align: "left"},
   
        
      
        ],
        tableData:[],
        tableTitle:'总数量:',
        loading:false,
         detailUserID:0,
      }
    },
    mounted(){
      // this.getTableData()
    },
    methods:{
      async getTableData(){
        let res = await this.$commonFun.postProxy('admin/site_balance/getBalanceRecord',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          this.tableData = res.data
        })
      },
      async editCompanyStationPrice(info){
        let params = {
          company_id: this.companyId,
          station_id:info.station_id,
          price:info.new_company_price,
          retail_prices:info.new_retail_prices
        }
        let res = await this.$commonFun.postProxy('admin/company/editCompanyStationPrice',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.getTableData()
            // this.$refs.table.resetSearchForm()
          })
        })
      },
      multiChangePrice(value){
        // this.$refs.table.tableData.forEach(item=>{
        this.tableData.forEach(item=>{
          if (item.company_price && item.company_price>0){
            item.new_company_price =value ? (parseFloat(item.price2)+parseFloat(value)).toFixed(2) : item.company_price;
            item.new_retail_prices =value ? parseFloat(parseFloat(item.retail_prices) - parseFloat(item.company_price) + parseFloat(item.new_company_price)).toFixed(2) : item.retail_prices;
          }else{
            item.new_company_price = 0;
            item.new_retail_prices = 0;
          }
        })
      },
      async multiSetPrice(){
        this.doingMultiSet = true
        // let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,price:this.multiPrice,do_time:this.do_time});
        // let data = this.$refs.table.tableData.map(item=>{
        let data = this.tableData.map(item=>{
          return {station_id:item.station_id,new_company_price:item.new_company_price,new_retail_prices:item.new_retail_prices}
        })
        let res = await this.$commonFun.postProxy('admin/company/multiEditCompanyStationPrice',{company_id: this.companyId,prices:data,do_time:this.do_time});
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg)
          this.getTableData()
          // this.$refs.table.resetSearchForm()
        })
        this.doingMultiSet = false
      },
      async exportStation(){
        let res = await this.$commonFun.postProxy('admin/company/exportCompanyStation',this.searchData)
        this.$commonFun.dealApiResult(res,()=>{
          let worksheet = XLSX.utils.aoa_to_sheet(res.data.data)
          let workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
          XLSX.writeFile(workbook,`${res.data.filename}.xlsx`)
        })
      },
      set_new_company_price(row,ttt){
        console.log('row0--0--',row)
        console.log('ttt---',ttt)
      },
          reloadPage(user_id){
        this.searchData.station_id = user_id
        this.getInfo()
      }

    },
      watch:{
      user_id(new_user_id,old_user_id){
        this.reloadPage(new_user_id)
      }
   }
    
  }
</script>

<style scoped lang="less">
  .conItem{
    display: flex;
    border: 1px solid #e8eaec;
    padding: 5px;
    align-items: center;
    >p{
      margin-right: 10px;
      text-align: center;
    }

    .bianhao{
      width: 80px;
    }
    .id{
      width: 35px;
    }
    .station_id{
      text-align: center;
      width: 100px;
      >span{
        display: block;
      }
    }
    .money{
       width: 100px;
      >span{
        display: block;
      } 
    }
    .front_balance{
          width: 100px;
      >span{
        display: block;
      } 
    }
    .after_balance{
          width: 100px;
      >span{
        display: block;
      } 
    }
    .ip{
    width: 100px;
      >span{
        display: block;
      } 
    }
    .status{
      width: 100px;
      >span{
        display: block;
      } 
    }
    .gas_name{
      width: 120px;
      >span{
        display: block;
      }
    }
    .remarks{
       width: 300px;
      >span{
        display: block;
      }
    }
    .user_name{
        width: 100px;
      >span{
        display: block;
      }
    }
    .create_time{
         width: 100px;
      >span{
        display: block;
      }
    }
    .update_time{
      width: 140px;
    }
    .price{
       width: 140px;
       >span{
         display: block;
       }
     }
    .station_price{
      width: 140px;
      >span{
        display: block;
      }
    }
    .spread_price{
      width: 100px;
    }
    .editPrice{
      flex: 1;
      .editPriceInput{
        width:60px;
        margin-right: 5px;
      }
      >span{
        display: block;
      }
    }
  }
</style>